import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Route from 'cio/routes/base';
import moment from 'moment-timezone';
import { DEFAULT_FORMAT } from 'cio/utils/broadcasts';

export default class IndexRoute extends Route {
  @service store;
  @service analytics;

  queryParams = {
    search: {
      replace: true,
      refreshModel: true,
    },
    tagIds: {
      replace: true,
      refreshModel: true,
    },
    page: {
      refreshModel: true,
    },
    channel: {
      refreshModel: true,
    },
    type: {
      refreshModel: true,
    },
    sort: {
      refreshModel: true,
    },
    asc: {
      refreshModel: true,
    },
    startTime: {
      refreshModel: true,
    },
    endTime: {
      refreshModel: true,
    },
    sendToUnsubscribed: {
      refreshModel: true,
    },
    subscriptionTopicId: {
      refreshModel: true,
    },
    objectTypeIds: {
      replace: true,
      refreshModel: true,
    },
  };

  model(params) {
    let {
      page,
      channel,
      type,
      search,
      tagIds,
      sort,
      asc,
      startTime,
      endTime,
      sendToUnsubscribed,
      subscriptionTopicId,
      objectTypeIds,
    } = params;

    return this.store.query('newsletter', {
      page: page - 1,
      channel,
      type,
      search,
      tagIds,
      sort,
      asc,
      start_time: startTime ? moment(startTime, DEFAULT_FORMAT).startOf('day').unix() : undefined,
      end_time: endTime ? moment(endTime, DEFAULT_FORMAT).endOf('day').unix() : undefined,
      sendToUnsubscribed,
      subscriptionTopicId,
      objectTypeIds,
    });
  }

  async setupController() {
    super.setupController(...arguments);

    let listController = this.controllerFor('broadcasts.list');
    listController.fetchCounts();
    await listController.callAnalyticsForList();
  }

  resetController(controller) {
    super.resetController(...arguments);
    controller.setDefaultQueryParams();
  }

  @action
  reloadModel() {
    this.refresh();
  }

  @action
  didTransition() {
    let controller = this.controllerFor('broadcasts.list');
    controller.transitionedIntoChildRoute(this.routeName);

    return true;
  }
}
